import {
  REPORT_CONTRACT_ITEMS_BY_CUSTOMER,
  REPORT_CONTRACT_ITEMS_BY_CUSTOMER_SUCCESS,
  REPORT_CONTRACT_ITEMS_BY_CUSTOMER_FAIL,
} from "./actionType";

const initialData = {
  reportContractItemsByCustomerLoading: false,
  reportContractItemsByCustomerData: [],
  reportContractItemsByCustomerError: "",
};

const Reports = (state = initialData, action) => {
  switch (action.type) {
    case REPORT_CONTRACT_ITEMS_BY_CUSTOMER:
      return {
        ...state,
        reportContractItemsByCustomerLoading: true,
      };
    case REPORT_CONTRACT_ITEMS_BY_CUSTOMER_SUCCESS:
      return {
        ...state,
        reportContractItemsByCustomerLoading: false,
        reportContractItemsByCustomerData: action.payload,
        reportContractItemsByCustomerError: "",
      };
    case REPORT_CONTRACT_ITEMS_BY_CUSTOMER_FAIL:
      return {
        ...state,
        reportContractItemsByCustomerLoading: false,
        reportContractItemsByCustomerData: [],
        reportContractItemsByCustomerError: action.payload,
      };
    default:
      return state;
  }
};

export default Reports;
